<template lang="pug">
footer
  .container
    .logo
      router-link(:to="`/${getLanguage}/`")
        img(src="@/assets/images/logo-bixter-footer.png" alt="bixter-logo-footer")
      language-selector.is-down.is-pulled-right(
        v-if="$lang.getSupportedLanguages()"
        :items="languageList"
        :current="getLanguage"
        @selected="changeLanguage($event)"
      )
    .nav
      <!--router-link.nav-item(:to="{name: 'AgriculturalTrainee', params: {lang: getLanguage}}") {{ gettext('Agricultural trainee') }}-->
      a.nav-item(href="https://www.bixter.training" target="_blanc") {{ gettext('Agricultural trainee') }}
      router-link.nav-item(v-if="false" :to="{name: 'HospitalityTrainee', params: {lang: getLanguage}}") {{ gettext('Hospitality trainee') }}
      router-link.nav-item(:to="{name: 'PartnerRegistration', params: {lang: getLanguage}}") {{ gettext('For partners') }}
      <!--a.nav-item(:href="howWorksLinks[getLanguage] || howWorksLinks['en']") {{ gettext('How it works') }}-->
      router-link.nav-item(:to="`/${getLanguage}/about-us`") {{ gettext('About us') }}
      router-link.nav-item(:to="`/${getLanguage}/privacy-policy`") {{ gettext('Privacy Policy') }}
      router-link.nav-item(:to="`/${getLanguage}/terms-of-sales`") {{ gettext('Terms of sales') }}
      <!--router-link.nav-item(:to="{name: 'Countries', params: {lang: getLanguage}}") {{ gettext('Countries') }}-->
      a.nav-item(href="https://www.bixter.training" target="_blanc") {{ gettext('Countries') }}
      router-link.nav-item(:to="`/${getLanguage}/contacts`") {{ gettext('Contacts') }}

    .footer-block
      .copyright {{ interpolate(gettext('Copyright %s %s Bixter.work. All rights reserved. Bixter.work is a registered trademark. Made in Scandinavia.'), ['&copy;', (new Date()).getFullYear()]) }}
      .soc-block
        a(target="blank" href="https://www.facebook.com/Bixterworkindk/" :title="gettext('Bixter facebook page')")
          .mdi.mdi-facebook
        a(target="blank" href="https://google.com" v-if="!inactive.HIDE_INACTIVE")
          .mdi.mdi-google-plus
        a(target="blank" href="https://twitter.com/BixterW")
          .mdi.mdi-twitter
        a(target="blank" href="https://www.linkedin.com" v-if="!inactive.HIDE_INACTIVE")
          .mdi.mdi-linkedin
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { gettext, interpolate } from '@/services/TranslateHandler'
import LanguageSelector from '@/components/language-selector'

const inactive = require('@/constants.json')

export default {
  components: {
    LanguageSelector
  },
  data () {
    return {
      languageList: [],
      inactive: inactive,
      howWorksLinks: {
        en: 'http://bixter.com/how-it-works-en/',
        da: 'http://bixter.com/how-it-works-dk/',
        de: 'http://bixter.com/how-it-works-de/',
        ru: 'http://bixter.com/how-it-works-ru/',
        uk: 'http://bixter.com/how-it-works-ua/',
        ro: 'http://bixter.com/how-it-works-ro/'
      }
    }
  },
  mounted () {
    this.getLanguageList()
  },
  methods: {
    gettext: gettext,
    interpolate: interpolate,
    ...mapActions([
      'languageRedirect',
      'receiveSupportedLanguages',
      'receiveTranslate',
      'setLanguage'
    ]),
    changeLanguage (lang) {
      this.receiveTranslate(lang.code).then(() => {
        this.setLanguage(lang.code)
        this.languageRedirect(lang.code)
      })
    },
    getLanguageList () {
      this.receiveSupportedLanguages().then(res => {
        this.languageList = res
      })
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  filters: {
    toLower: function (value) {
      return value.toLowerCase()
    }
  }
}
</script>

<style scoped lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/parts/footer/index.vue